package com.devi3east.bashbuddy.cart.domain.models

import kotlinx.serialization.Serializable
import com.devi3east.bashbuddy.features.events.common.data.models.Ticket

@Serializable
data class CartItem(
    val ticket: Ticket,
    val quantity: Int,
    val shippingSelected: Boolean = false
)